module.exports = __webpack_public_path__ + "img/mocking-facebook.50cce823.png";